module.exports = __webpack_public_path__ + "img/liolio-lose.06ff582e.svg";